import { render, staticRenderFns } from "./APCDelconCreateAdmin.vue?vue&type=template&id=04dc8146&scoped=true"
import script from "./APCDelconCreateAdmin.vue?vue&type=script&lang=js"
export * from "./APCDelconCreateAdmin.vue?vue&type=script&lang=js"
import style0 from "./APCDelconCreateAdmin.vue?vue&type=style&index=0&id=04dc8146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc8146",
  null
  
)

export default component.exports